import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as listener from "./index";

export function init(
	ifdto: ifbase.ifDto,
	onChange: (event: sonbp.type.event) => void,
	onComplete: (event: sonbp.type.event) => void,
	onCancel: (event: sonbp.type.event) => void,
	onExchange: (a: { waku: any, img: any }, b: { waku: any, img: any }) => void ): void {

	// [sonbp] セレクタ 作成
	ifdto.bpSelector = new listener.poscaSelector(ifdto);
	ifdto.bpSelector.onChange(function (e) {
		onChange(e);
	});

	// [sonbp] 画像入替え兼用セレクター 作成
	ifdto.bpSelectorWithExchange = new listener.poscaSelectorWithExchange(ifdto);
	ifdto.bpSelectorWithExchange.onChange(function (e) {
		onChange(e);
	});
	ifdto.bpSelectorWithExchange.onExchange(function (a: { waku: any, img: any }, b: { waku: any, img: any }) {
		onExchange(a, b);
	});
	ifdto.bpSelectorWithExchangeSP = new listener.poscaSelectorWithExchangeSP(ifdto);
	ifdto.bpSelectorWithExchangeSP.onChange(function (e) {
		onChange(e);
	});
	ifdto.bpSelectorWithExchangeSP.onExchange(function (a: { waku: any, img: any }, b: { waku: any, img: any }) {
		onExchange(a, b);
	});

	// [sonbp] イメージドラッガー 作成
	ifdto.bpImageDragger = new listener.poscaImageDragger(ifdto);
	ifdto.bpImageDragger.onComplete(function (e) {
		onComplete(e);
	});
	ifdto.bpImageDragger.onCancel(function (e) {
		onCancel(e);
	});

	// [sonbp] 銀塩・印刷フロント描画用リスナー
	ifdto.bpFrontDrawer = new listener.poscaFrontDrawer(ifdto);
}
